import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/store/store';

type UiLoadingState = {
  globalLoadingCount: number; // 用計數避免重疊的 async 把彼此關掉
};

const initialState: UiLoadingState = {
  globalLoadingCount: 0,
};

const uiLoadingSlice = createSlice({
  name: 'uiLoading',
  initialState,
  reducers: {
    startGlobalLoading(state) {
      state.globalLoadingCount += 1;
    },
    stopGlobalLoading(state) {
      state.globalLoadingCount = Math.max(0, state.globalLoadingCount - 1);
    },
    resetGlobalLoading(state) {
      state.globalLoadingCount = 0;
    },
  },
});

export const { startGlobalLoading, stopGlobalLoading, resetGlobalLoading } = uiLoadingSlice.actions;

export default uiLoadingSlice.reducer;

// selector
export const selectIsGlobalLoading = (state: RootState) => state.uiLoading.globalLoadingCount > 0;
